var _defs, _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMenuTogetherDActive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "menu_together_d_active",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 70,
    height: 25,
    viewBox: "0 0 70 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uC0AC\\uAC01\\uD615_178244",
    "data-name": "\\uC0AC\\uAC01\\uD615 178244",
    d: "M0,0H15.049V7.526H0Z",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_6941",
    "data-name": "\\uD328\\uC2A4 6941",
    d: "M886.941,1772.867H901.99v7.526l-14.557-1.726Z",
    transform: "translate(-886.941 -1772.867)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_6942",
    "data-name": "\\uD328\\uC2A4 6942",
    d: "M923.529,1779l-14.557,1.726V1773.2h15.049Z",
    transform: "translate(-908.972 -1773.2)",
    fill: "none"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_207005",
    "data-name": "\\uC0AC\\uAC01\\uD615 207005",
    width: 70,
    height: 25,
    fill: "none"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1674",
    "data-name": "\\uADF8\\uB8F9 1674",
    transform: "translate(4.914 -7)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill_1",
    "data-name": "Fill 1",
    d: "M33.9,15.108A4.11,4.11,0,1,1,29.791,11,4.11,4.11,0,0,1,33.9,15.108",
    fill: "#5d9df0"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_5",
    "data-name": "Group 5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Clip_4-2",
    "data-name": "Clip 4-2",
    d: "M897.86,1775.306h15.049v7.526H897.86Z",
    transform: "translate(-875.594 -1753.912)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1668",
    "data-name": "\\uADF8\\uB8F9 1668"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1667",
    "data-name": "\\uADF8\\uB8F9 1667",
    transform: "translate(22.266 21.394)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5-2",
    "data-name": "Group 5-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill_3",
    "data-name": "Fill 3",
    d: "M0,7.526a7.527,7.527,0,1,1,15.054,0Z",
    fill: "#5d9df0"
  }))))), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1-2",
    "data-name": "Fill 1",
    d: "M23.281,15.109a2.763,2.763,0,1,1-2.763-2.762,2.763,2.763,0,0,1,2.763,2.762",
    fill: "#5d9df0"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_5-2-2",
    "data-name": "Group 5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Clip_4-2-2",
    "data-name": "Clip 4-2",
    d: "M886.941,1772.867H901.99v7.526l-14.557-1.726Z",
    transform: "translate(-873.855 -1753.523)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1670",
    "data-name": "\\uADF8\\uB8F9 1670"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1669",
    "data-name": "\\uADF8\\uB8F9 1669",
    transform: "translate(13.086 19.344)",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5-2-3",
    "data-name": "Group 5-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill_3-2",
    "data-name": "Fill 3",
    d: "M7.506,5.778C7,5.778,1.492,5.8,1.492,5.8A5.9,5.9,0,0,1,7.606.079a7.121,7.121,0,0,1,4,1.194,5.838,5.838,0,0,0-4.1,4.505Z",
    fill: "#5d9df0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5-2-4",
    "data-name": "Group 5-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill_3-3",
    "data-name": "Fill 3",
    d: "M912.829,1774.117a7.122,7.122,0,0,1,4-1.194c3.781.075,6.145,2.341,7.114,5.721,0,0-6.507-.025-7.014-.022a5.838,5.838,0,0,0-4.1-4.505Z",
    transform: "translate(-891.064 -1772.876)",
    fill: "#5d9df0"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5-3",
    "data-name": "Group 5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Clip_4-2-3",
    "data-name": "Clip 4-2",
    d: "M922.033,1779l-14.557,1.727V1773.2h15.049Z",
    transform: "translate(-877.126 -1753.577)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1672",
    "data-name": "\\uADF8\\uB8F9 1672"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1671",
    "data-name": "\\uADF8\\uB8F9 1671",
    transform: "translate(31.608 19.623)",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5-2-5",
    "data-name": "Group 5-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill_3-4",
    "data-name": "Fill 3",
    d: "M3.445,1.272a7.128,7.128,0,0,1,4-1.193c3.781.074,6.173,2.2,6.114,5.72,0,0-5.507-.025-6.014-.021a5.838,5.838,0,0,0-4.1-4.506Z",
    fill: "#5d9df0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5-2-6",
    "data-name": "Group 5-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill_3-5",
    "data-name": "Fill 3",
    d: "M894.781,1778.955c-.507,0-7.014.021-7.014.021.97-3.379,3.333-5.646,7.114-5.72a7.127,7.127,0,0,1,4,1.193,5.838,5.838,0,0,0-4.1,4.506Z",
    transform: "translate(-905.595 -1773.209)",
    fill: "#5d9df0"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5-4",
    "data-name": "Group 5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Clip_4-2-4",
    "data-name": "Clip 4-2",
    d: "M924.326,1780.393H909.277v-7.526h15.049Z",
    transform: "translate(-877.413 -1753.523)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1-3",
    "data-name": "Fill 1",
    d: "M41.912,15.109a2.762,2.762,0,1,1-2.762-2.762,2.762,2.762,0,0,1,2.762,2.762",
    fill: "#5d9df0"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuTogetherDActive);
export default __webpack_public_path__ + "static/media/menu_together_d_active.9ba8d224e19f68136d6bc7039f9f15d8.svg";
export { ForwardRef as ReactComponent };